export const getRoleDisplayName = (role) => {
  switch (role) {
    case "manager":
      return "Property Manager";
    case "landlord":
      return "Landlord";
    case "tenant":
      return "Tenant";
    default:
      return role;
  }
};

export const getInitials = (name) => {
  if (!name) return "U";
  return name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .substring(0, 2)
    .toUpperCase();
};

export const getShortName = (fullName) => {
  if (!fullName) return "User";
  const parts = fullName.trim().split(" ");
  if (parts.length === 1) return parts[0];
  const firstName = parts[0];
  const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
  return `${firstName} ${lastInitial}.`;
};
